// extracted by mini-css-extract-plugin
export var chatHtmlText = "_qh-2";
export var chatLink = "_qh-0";
export var chatText = "_qh-1";